import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn } from '@angular/router';
import { AuthStore } from '../store/auth.store';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn | CanMatchFn = () => {
  const authStore = inject(AuthStore);
  const authService = inject(AuthService);

  if (authStore.isAuthenticated()) {
    return true;
  }

  authService.logout();
  return false;
};
